module.exports = __webpack_public_path__ + "img/account.5e5f09af.png";